/* eslint-disable complexity, react-hooks/exhaustive-deps, @next/next/no-img-element, sonarjs/cognitive-complexity */
import {
  faCheck,
  faChevronDown,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, {
  useEffect,
  useContext,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import Cookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import SubCatRedirectedBanner from '../../components/SubCatRedirectedBanner';
import VipPaywallDynamic from '../../components/VIpPaywallDynamic';
import VipBanner from '../../components/VipBanner';
import { WellnessBanner } from '../../components/WellnessHeader';
import { logToSplunk } from '../../components/_generic/axiosSplunk/axiosSplunk';
import TimerTo, { TIMER_TYPES } from '../../components/_generic/timer/TimerTo';
import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import FacetedNavigationContainer from '../../components/category/FacetedNavigationContainer';
import FeaturedSubcatsContainer from '../../components/category/FeaturedSubcatsContainer';
import MerchandisingModule from '../../components/category/MerchandisingModule';
import BottomDeals from '../../components/deal/BottomDeals';
import ConnectedBottomDeals, {
  LAYOUT_TYPES,
} from '../../components/deal/ConnectedBottomDeals';
import {
  dealsGetKeyGenerator,
  fetchDeals,
  fetchNewSubcatDeals,
} from '../../components/deal/ConnectedBottomDeals/helpers';
import TrustBox from '../../components/deal/TrustBox';
import CategoryMainDeal from '../../components/deal/mainDeals/CategoryMainDeal';
import SecondaryDeal from '../../components/deal/secondaryDeal';
import FilterSubCat from '../../components/filters/FilterSubCat';
import Filters from '../../components/filters/Filters';
import SelectedFilters from '../../components/filters/SelectedFilters';
import { DiscountCoupon } from '../../components/forms/Subscriber/components/DiscountCoupon';
import HyperLocalFallbackMessage from '../../components/hyper-local-fallback-mesage/HyperLocalFallbackMessage';
import RefereeAlreadyRegisteredBanner from '../../components/refer-a-friend/RefereeAlreadyRegisteredBanner';
import RefereeWelcomeBanner from '../../components/refer-a-friend/RefereeWelcomeBanner';
import Tiles from '../../components/tiles/Tiles';
import { VIP_BG } from '../../config/constants/images';
import { PAGE_TYPES, VIP_QUALIFIERS } from '../../config/constants/page-types';
import COOKIES from '../../config/cookies/cookies';
import {
  DESKTOP_PAGE_SIZE,
  HREF_LANG_URL_DOMAINS,
} from '../../config/links/links';
import {
  NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY,
  NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY,
  TIMEOUT_CHECK_NOT_FOUND,
  PAGE_CACHE_AGE_SEC,
  SITE_WOWCHERIE,
  SITE_WOWCHER,
  SITE_LIVINGSOCIAL,
  SITE_LIVINGSOCIAL_IE,
  filterPopularity,
  FILTER_SORTBY,
} from '../../config/setup/setup';
import { NO_FILTER_RESULTS, TYPE_CATEGORY_DEALS } from '../../config/text/text';
import { isOspValid, trackPage, updateDod } from '../../helpers/analytics';
import { isIELocation } from '../../helpers/deals';
import { isFiltered } from '../../helpers/filters';
import { isFindPage, isFindPath, locationList } from '../../helpers/find';
import {
  isIESite,
  isLivingSocialBrand,
  isWowcherBrand,
} from '../../helpers/pages';
import { isMobileViewport, isNotDesktop } from '../../helpers/screen';
import { useIsSSR } from '../../helpers/ssr';
import { parseWowcherPath, pathLocationInfo } from '../../helpers/url';
import DealsLayout from '../../layouts/DealsLayout';
import ThemeContext from '../../providers/ThemeProvider';
import {
  getClientSideBuyAgainDeals,
  getClientSideDeals,
} from '../../redux/actions/clientRender';
import { resetBuyAgainDeals } from '../../redux/actions/deals';
import { getGifting } from '../../redux/actions/giftting';
import {
  getServerSideEssentials,
  getServerSideDeals,
} from '../../redux/actions/ssr';
import { getTiles } from '../../redux/actions/tiles';
import { wrapper } from '../../redux/store/store';
import {
  getEarlyBirdDeals,
  getPopularLocations,
} from '../../services/hyperlocal';
import { getPromocode } from '../../services/vouchers';

const Deals = ({ popularLocationsData, url, initialIsNewFilterApplied }) => {
  const router = useRouter();
  const [
    mainDeal,
    deals,
    facetedNavigation,
    secondaryDealsArray,
    ssr,
    tiles,
    nomoredeals,
    filterDeals,
    location,
    locations,
  ] = useSelector((state) => [
    state.deals.mainDeal,
    state.deals.deals,
    state.deals.facetedNavigation,
    state.deals.secondaryDealsArray,
    state.deals.ssr,
    state.tiles,
    state.deals.nomore,
    state.filters,
    state.locations.location,
    state.locations.locations,
  ]);
  const [initialFilters] = useState(() => {
    if (typeof window === 'undefined') return {};

    const parameters = new URLSearchParams(window.location.search);
    const filtersFromUrl = {};

    parameters.forEach((value, key) => {
      // Only include keys starting with 'f_'
      if (key.startsWith('f_')) {
        const decodedValue = decodeURIComponent(value);
        filtersFromUrl[key] = decodedValue.includes(',')
          ? decodedValue.split(',')
          : decodedValue;
      }
    });

    // Remove 'f_vip' filter if it's exactly 'true'
    if (filtersFromUrl.f_vip === 'true') {
      delete filtersFromUrl.f_vip;
    }

    return filtersFromUrl;
  });
  const [isNewFilterApplied, setIsNewFilterApplied] = useState(
    initialIsNewFilterApplied,
  );
  const additionalContentText = facetedNavigation?.additionalContent;
  const [isAuthCheckFinished] = useSelector((state) => [
    state.user.isAuthCheckFinished,
  ]);
  const isLoggedIn = useSelector((state) => state.user.isAuthenticated);
  const isMobile = isMobileViewport();
  // without this as a hook, the html between ssr and client doesn't match and
  // generates unexpected html.
  const isSSR = useIsSSR();
  const filterSubCatRef = useRef();
  const [liveFilters, setLiveFilters] = useState(
    facetedNavigation?.filters || {},
  );
  const [resultCount, setResultCount] = useState(facetedNavigation?.count);
  const path = router.asPath;
  const pathUrl = parseWowcherPath(path);
  const isHrefCompatible = path.includes('shop') || path.includes('travel');
  const isVipHubPage = VIP_QUALIFIERS.includes(pathUrl.pageType);
  const { referralCredit } = useSelector((state) => state.user.userprofile);
  const isVipUser = useSelector((state) => state.user.userprofile.vipUser);
  const { isLocationPage } = pathLocationInfo(path, locations);
  const isShopOrLocal =
    Boolean(pathUrl.pageType === PAGE_TYPES.homepage) || isLocationPage;

  const theme = useContext(ThemeContext);
  // RAF Enabled welcome banner controlled by the env variable (Wowcher only)
  const isWowcher = isWowcherBrand();
  const isLivingSocial = isLivingSocialBrand();
  const rafEnabled = JSON.parse(process.env.NEXT_PUBLIC_RAF_ENABLED === 'true');
  const currentNumberTiles = tiles?.tiles?.length || 0;

  const dispatch = useDispatch();
  const [pageNotFound, setPageNotFound] = useState(false);
  const [redirectToCategory, setRedirectToCategory] = useState('');
  const [previousAsPath, setRouterAsPath] = useState('');
  const [promoCode, setPromoCode] = useState({});
  const [enableWelcome, setEnableWelcome] = useState(false);
  const [showSortBy, setShowSortBy] = useState(false);
  const [priceStats, setPriceStats] = useState(null);
  const { searchParams } = parseWowcherPath(router.asPath);
  const sortBy = useMemo(() => searchParams.get(FILTER_SORTBY) ?? '-1', [
    searchParams,
  ]);
  const searchContainerRef = useRef(null);
  const pageInitial = useRef(0);

  const updateInitialPage = (defaultValue = 0) => {
    pageInitial.current = defaultValue;
  };
  const noMoreFiltersData = useRef(false);
  const noMoreDealsData = useRef(false);
  const updateNoMoreFilters = (defaultValue = 0) => {
    noMoreFiltersData.current = defaultValue;
  };
  const updateNoMoreDeals = (defaultValue = 0) => {
    noMoreDealsData.current = defaultValue;
  };

  const isSubCat = isFindPath(url);

  const [earlyBirdData, setEarlyBirdData] = useState([]);
  const [chosenFilters, setChosenFilters] = useState([]);
  const [shouldStick, setShouldStick] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);
  const filterRef = useRef(null);

  const handleFiltersUpdate = useCallback(
    (newFilters) => {
      if (!newFilters || Object.keys(newFilters).length === 0) return;

      const keysLive = Object.keys(liveFilters);
      const keysNew = Object.keys(newFilters);

      const isSameLength = keysLive.length === keysNew.length;
      const allKeysMatch = keysLive.every((key) =>
        Object.prototype.hasOwnProperty.call(newFilters, key),
      );
      if (isSameLength && allKeysMatch) {
        let allValuesMatch = true;
        for (const key of keysLive) {
          if (liveFilters[key] !== newFilters[key]) {
            allValuesMatch = false;
            break;
          }
        }
        if (allValuesMatch) {
          return;
        }
      }
      if (!newFilters || Object.keys(newFilters).length === 0) {
        logToSplunk(
          {
            currentFilters: Object.keys(liveFilters || {}),
            reason: 'Empty filters blocked to preserve state',
            type: 'FilterGuardSkipEmpty',
          },
          'FilterStateGuard',
        );

        return;
      }
      setLiveFilters(newFilters);
    },
    [liveFilters],
  );

  useEffect(() => {
    // Sync client-side cookie value after mount
    const isSDCookie = Cookies.load(COOKIES.sdTest) === 'b';
    const isNearMePage = path?.includes('/near-me/');
    setIsNewFilterApplied(isSDCookie && isSubCat && !isNearMePage);
  }, []);

  useEffect(() => {
    const headerDiv = document.querySelector('.header');
    if (headerDiv) {
      const headerHeightFromDiv = headerDiv.getBoundingClientRect().height;
      setHeaderHeight(headerHeightFromDiv);
    }
  }, []);

  useEffect(() => {
    if (facetedNavigation?.stats) {
      setPriceStats(facetedNavigation?.stats);
    }
  }, [facetedNavigation?.stats]);

  useEffect(() => {
    if (isNewFilterApplied && isMobile) {
      const TopContainer = 350;
      const threshold = 50;
      const minScrollDelta = 15; // minimum scroll delta to trigger state change
      let lastChangeTime = 0;
      const minChangeInterval = 100;

      const appearThreshold = TopContainer + threshold;

      const updateStickyState = () => {
        const currentScrollY = window.pageYOffset;
        const scrollDelta = currentScrollY - lastScrollY.current;
        const now = Date.now();

        // Debounce state changes
        if (now - lastChangeTime < minChangeInterval) {
          ticking.current = false;

          return;
        }

        if (Math.abs(scrollDelta) < minScrollDelta) {
          ticking.current = false;

          return;
        }

        if (currentScrollY <= TopContainer) {
          if (shouldStick) {
            setShouldStick(false);
            lastChangeTime = now;
          }
        } else if (scrollDelta < 0 && currentScrollY > appearThreshold) {
          if (!shouldStick) {
            setShouldStick(true);
            lastChangeTime = now;
          }
        } else if (scrollDelta > 0 && shouldStick) {
          setShouldStick(false);
          lastChangeTime = now;
        }

        lastScrollY.current = currentScrollY;
        ticking.current = false;
      };

      const handleScroll = () => {
        if (!ticking.current) {
          window.requestAnimationFrame(updateStickyState);
          ticking.current = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isNewFilterApplied, isMobile, shouldStick]);

  const fetchData = async () => {
    const response = await getEarlyBirdDeals();
    setEarlyBirdData(response?.deals);
  };
  const fetchPromoCode = async () => {
    try {
      const result = await getPromocode(pathUrl);
      setPromoCode(result);
    } catch (error) {
      console.error('Promocode endpoint failed with', error);
    }
  };

  const handleClearAllFilters = useCallback(() => {
    //  just a passthrough
    filterSubCatRef.current?.handleClearAllFilters();
  }, []);
  const handleRemoveFilter = useCallback((category, value) => {
    // just a passthrough
    filterSubCatRef.current?.handleRemoveFilter(category, value);
  }, []);
  const handleSortSelection = useCallback((value) => {
    filterSubCatRef.current?.handleSortSelection(value);
  }, []);

  useEffect(() => {
    // Only make this call if it is the vip hub page
    if (isVipHubPage) {
      fetchData();
    }
    if (pathUrl.details.subCategory || pathUrl.details.category) {
      fetchPromoCode();
    }

    if (
      localStorage.getItem('src') === 'welcome' &&
      Cookies.load(COOKIES.customerToken)
    ) {
      setEnableWelcome(true);
      localStorage.removeItem('src');
    }
  }, []);

  useEffect(() => {
    if (filterDeals.nomore === noMoreFiltersData.current) return;

    updateNoMoreFilters(filterDeals.nomore);
  }, [filterDeals]);

  useEffect(() => {
    if (nomoredeals === noMoreDealsData.current) return;
    updateNoMoreDeals(nomoredeals);
  }, [nomoredeals]);

  useEffect(() => {
    if (previousAsPath === router.asPath.split('?')[0].toLowerCase()) {
      // we ignore if only the parameters are differents
      return;
    }
    setRouterAsPath(router.asPath.toLowerCase());

    dispatch(
      getClientSideDeals({
        pageSize: NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY,
        path: router.asPath,
        query: {
          ...router.query,
        },
        secondaryDealsCount: NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY,
      }),
    );
    updateInitialPage(0);

    if (!(router?.query?.rSub === undefined || router?.query?.rSub === null)) {
      setRedirectToCategory(`${pathUrl.pathArray[2]}`);
    }
    dispatch(getTiles(router.asPath, tiles.apiUrl, currentNumberTiles));
  }, [router.asPath]);

  const getKeyGenerator = dealsGetKeyGenerator({
    firstPageSize: NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY,
    isCategoryPage: true,
    pageSize: NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY - 2,
  });

  useEffect(() => {
    setTimeout(() => {
      if (
        !ssr &&
        (!mainDeal || Object.keys(mainDeal).length === 0) &&
        (!deals || !deals.length)
      ) {
        // if this is a subcategory, redirect to the category
        if (pathUrl?.pathArray?.length === 4) {
          const url = `/${pathUrl.pathArray[0]}/${pathUrl.pathArray[1]}/${pathUrl.pathArray[2]}?rSub`;
          router.replace(url, url);
        } else {
          setPageNotFound(true);
        }
      }
    }, TIMEOUT_CHECK_NOT_FOUND);
  }, [ssr]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getClientSideBuyAgainDeals());
    } else {
      dispatch(resetBuyAgainDeals());
    }
  }, [isLoggedIn]);

  useEffect(() => {
    trackPage({
      dealData: mainDeal,
      dealId: mainDeal.id,
      dealLocation: router.query.slug[0],
      location: { name: location.name, shortName: location.shortName },
      products: `;${mainDeal.id};;`,
    });
  }, []);

  useEffect(() => {
    // Get GiftWrap info
    dispatch(getGifting());
  }, [location.shortName]);

  useEffect(() => {
    if (isOspValid()) {
      let pageTrackingData = deals;
      if (mainDeal && pageTrackingData && secondaryDealsArray) {
        pageTrackingData = [mainDeal, ...pageTrackingData];
      }
      const noOfSimilarDeals = pageTrackingData.reduce(
        (count, currentValue) => {
          return (
            count + (currentValue.isSimilarRecommendedDeal === true ? 1 : 0)
          );
        },
        0,
      );

      const noOfPersonalisedDeals = pageTrackingData.reduce(
        (count, currentValue) => {
          return (
            count +
            (currentValue.isPersonalisedRecommendedDeal === true ? 1 : 0)
          );
        },
        0,
      );
      updateDod({ noOfPersonalisedDeals, noOfSimilarDeals });
    }
  }, [deals]);

  const [isFirstPage] = useState(!router.query.page);

  if (pageNotFound) {
    // Import only if needed
    const DynamicComponent = dynamic(() =>
      import('../../components/errors/Form404Block'),
    );

    return <DynamicComponent statusCode={404} />;
  }

  const { details } = parseWowcherPath(router.asPath);

  const isWellnessPage = details.localDealLocation === PAGE_TYPES.wellness;
  if (typeof window !== 'undefined') {
    window.__CWVL = 'categoryPage';
  }

  const reviewScore = mainDeal.reviewSummary?.average || null;
  const reviewCount = mainDeal.reviewSummary?.total || null;

  return (
    <>
      {isNewFilterApplied && chosenFilters?.length > 0 && (
        <Head>
          <meta content="NOINDEX, FOLLOW" name="robots" />
        </Head>
      )}
      {isWowcher && isHrefCompatible && (
        <Head>
          <link
            href={`${
              HREF_LANG_URL_DOMAINS[
                process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'
              ][SITE_WOWCHER]
            }${path}`}
            hrefLang="en-GB"
            rel="alternate"
          />
          <link
            href={`${
              HREF_LANG_URL_DOMAINS[
                process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'
              ][SITE_WOWCHERIE]
            }${path}`}
            hrefLang="en-IE"
            rel="alternate"
          />
          <link
            href={`${
              HREF_LANG_URL_DOMAINS[
                process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'
              ][SITE_WOWCHER]
            }${path}`}
            hrefLang="x-default"
            rel="alternate"
          />
        </Head>
      )}
      {isLivingSocial && isHrefCompatible && (
        <Head>
          <link
            href={`${
              HREF_LANG_URL_DOMAINS[
                process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'
              ][SITE_LIVINGSOCIAL]
            }${path}`}
            hrefLang="en-GB"
            rel="alternate"
          />
          <link
            href={`${
              HREF_LANG_URL_DOMAINS[
                process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'
              ][SITE_LIVINGSOCIAL_IE]
            }${path}`}
            hrefLang="en-IE"
            rel="alternate"
          />
          <link
            href={`${
              HREF_LANG_URL_DOMAINS[
                process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'
              ][SITE_LIVINGSOCIAL]
            }${path}`}
            hrefLang="x-default"
            rel="alternate"
          />
        </Head>
      )}
      <div className="cat-page container-wrapper">
        <>
          {isVipHubPage && (
            <img alt="background-black" className="bg-container" src={VIP_BG} />
          )}
          {isFirstPage && (
            <>
              {Object.keys(promoCode).length > 0 && (
                <div className="timer-banner">
                  <TimerTo
                    heading={promoCode.banner}
                    id="category-timer-1"
                    redirectToTC={promoCode.termsAndConditions}
                    type={TIMER_TYPES.category} // TODO: confirm mobile position, get timestamp from new api
                    unixTimestampTo={promoCode.endDate}
                  />
                </div>
              )}
              <TrustBox isPageDarkBackground={isVipHubPage} />
              <div className={`container head-container`}>
                {/* Breadcrumb + Main Deal + side menu + hero deals */}
                <div className="row cols main-deal-wrapper">
                  {isWellnessPage ? (
                    <WellnessBanner theme={theme} />
                  ) : (
                    <Tiles />
                  )}
                  {redirectToCategory && (
                    <SubCatRedirectedBanner
                      redirectToCategory={redirectToCategory}
                    />
                  )}
                  {isVipHubPage ? <VipBanner /> : <div />}
                  <BreadCrumb />
                  {details?.isHyperlocal ? <HyperLocalFallbackMessage /> : null}
                  {isNewFilterApplied && (
                    <div className="faceted-navigation-container">
                      <FacetedNavigationContainer
                        isNewFilterApplied={isNewFilterApplied}
                        isSubCat={isSubCat}
                      />
                      <FeaturedSubcatsContainer
                        newFilter={isNewFilterApplied}
                      />
                      <hr className="separator" />
                    </div>
                  )}
                  {!isNewFilterApplied && (
                    <>
                      {!isVipHubPage && (
                        <div
                          className={classNames('cols-20 side-menu item', {
                            'side-menu-shop-and-local': isShopOrLocal,
                          })}
                        >
                          <FacetedNavigationContainer />
                        </div>
                      )}
                      <div
                        className={`${
                          isVipHubPage ? 'cols-66' : 'cols-50'
                        } main-deal main-deal-item item`}
                        data-review-count={reviewCount}
                        data-review-score={reviewScore}
                      >
                        <CategoryMainDeal deal={mainDeal} />
                      </div>

                      <div
                        className={`${
                          isVipHubPage ? 'cols-33' : 'cols-20'
                        }  hero-deals main-deal-item item`}
                      >
                        <div className="cols-display">
                          {secondaryDealsArray.map((deal) => {
                            return (
                              <SecondaryDeal
                                deal={deal}
                                extraclasses={`full-width ${
                                  isVipHubPage ? 'small-deal-vip' : 'small-deal'
                                } `}
                                isXS
                                key={deal.id}
                                ppNotVisible
                              />
                            );
                          })}
                        </div>
                      </div>
                    </>
                  )}
                  {isNewFilterApplied && (
                    <div className="subcat-filter-deals-wrapper">
                      {!isVipHubPage && (
                        <div
                          className={classNames('cols-25 item', {
                            'sticky-filter': shouldStick,
                            'sticky-side-menu': !isMobile,
                          })}
                          ref={filterRef}
                        >
                          <FilterSubCat
                            count={resultCount}
                            filterData={liveFilters}
                            initialFilters={initialFilters}
                            isSubCat={isSubCat}
                            priceStats={priceStats}
                            ref={filterSubCatRef}
                            setChosenFilters={setChosenFilters}
                          />
                        </div>
                      )}
                      <div className="new-filter-container">
                        <div className="right-content">
                          <div className="selected-filter-desktop">
                            <SelectedFilters
                              activeFilters={chosenFilters}
                              onClearAll={handleClearAllFilters}
                              onRemoveFilter={handleRemoveFilter}
                            />
                          </div>
                          <div className="sort-btn-wrapper">
                            <button
                              className="sort-btn"
                              onClick={() => setShowSortBy(!showSortBy)}
                              type="button"
                            >
                              <span>Sort By</span>
                              <FontAwesomeIcon
                                icon={showSortBy ? faChevronUp : faChevronDown}
                              />
                            </button>
                            {showSortBy && (
                              <div className="sort-dropdown">
                                {filterPopularity.map((option) => (
                                  <button
                                    className={`sort-option ${
                                      sortBy === option.value ? 'selected' : ''
                                    }`}
                                    key={option.value}
                                    onClick={() => {
                                      handleSortSelection(option.value);
                                      setShowSortBy(false);
                                    }}
                                    type="button"
                                  >
                                    <span>{option.name}</span>
                                    {sortBy === option.value && (
                                      <FontAwesomeIcon icon={faCheck} />
                                    )}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="with-sticky-filter-wrapper">
                          {isSSR && (
                            <BottomDeals
                              deals={deals}
                              emptyFilters={Boolean(
                                filterDeals && filterDeals.empty,
                              )}
                              filterDeals={
                                filterDeals && filterDeals.deals
                                  ? filterDeals.deals
                                  : []
                              }
                              isNewFilterApplied={isNewFilterApplied}
                              loaded={
                                filterDeals && filterDeals.loaded
                                  ? filterDeals.loaded
                                  : false
                              }
                              pageInitial={pageInitial.current}
                            />
                          )}
                          <ConnectedBottomDeals
                            additionalContentText={additionalContentText}
                            chosenFilters={chosenFilters}
                            emptyText={isFiltered() ? NO_FILTER_RESULTS : ''}
                            fetcherFunction={
                              isNewFilterApplied
                                ? fetchNewSubcatDeals
                                : fetchDeals
                            }
                            firstPageSize={
                              NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY
                            }
                            getKeyGenerator={getKeyGenerator}
                            isNewFilterApplied={isNewFilterApplied}
                            newFilter
                            numberSecondaryDeals={
                              NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY
                            }
                            onFiltersUpdate={handleFiltersUpdate}
                            pageSize={
                              NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY - 2
                            }
                            popularLocationsData={popularLocationsData}
                            setResultCount={setResultCount}
                            sideDealsLocal={mainDeal?.display?.sideDealsLocal}
                            templateType={LAYOUT_TYPES.twoByTwo}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {!isNewFilterApplied && <FeaturedSubcatsContainer />}
              </div>
            </>
          )}
          {path === `/deals/vip` && isVipUser && (
            <MerchandisingModule
              earlyBirdData={earlyBirdData}
              path={router.asPath}
              position={1}
            />
          )}
          {!isSubCat && <Filters />}
          {/* Bottom deals*/}
          {/* only render the bottom deals for ssr */}
          {(!isNewFilterApplied || isNotDesktop()) && (
            <>
              {isSSR && (
                <BottomDeals
                  deals={deals}
                  emptyFilters={Boolean(filterDeals && filterDeals.empty)}
                  filterDeals={
                    filterDeals && filterDeals.deals ? filterDeals.deals : []
                  }
                  loaded={
                    filterDeals && filterDeals.loaded
                      ? filterDeals.loaded
                      : false
                  }
                  pageInitial={pageInitial.current}
                />
              )}
              {
                <ConnectedBottomDeals
                  additionalContentText={additionalContentText}
                  emptyText={isFiltered() ? NO_FILTER_RESULTS : ''}
                  fetcherFunction={
                    isNewFilterApplied ? fetchNewSubcatDeals : fetchDeals
                  }
                  firstPageSize={NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY}
                  getKeyGenerator={getKeyGenerator}
                  isNewFilterApplied={isNewFilterApplied}
                  numberSecondaryDeals={NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY}
                  pageSize={NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY - 2}
                  popularLocationsData={popularLocationsData}
                  sideDealsLocal={mainDeal?.display?.sideDealsLocal}
                  templateType={
                    pathUrl.details.isTravel
                      ? LAYOUT_TYPES.twoByTwo
                      : LAYOUT_TYPES.grid
                  }
                />
              }
            </>
          )}
        </>
        {/* Referee Welcome Banner(For Wowcher Only): Show 1st time When user is coming from Refer a friend */}
        {isWowcher && rafEnabled ? (
          <RefereeWelcomeBanner referralCredit={referralCredit} />
        ) : null}
        {isWowcher ? <RefereeAlreadyRegisteredBanner /> : null}
        {!isVipUser && isVipHubPage && isAuthCheckFinished && (
          <VipPaywallDynamic
            ariaLabelledBy="id-subscribe"
            backdropClassName="popup-bg-white"
            extraClasses="confirmation-popup-container"
            showHeader
            showModal
            size="lg"
            title=""
          />
        )}
        {enableWelcome && (
          <DiscountCoupon onClose={() => setEnableWelcome(false)} />
        )}
        <style jsx>{`
          .cat-page {
            padding-bottom: 60px;
          }
          .sticky-filter {
            position: fixed;
            top: ${headerHeight}px;
            width: 100%;
            z-index: 1000;
            background: white;
            margin-top: 0px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            animation: slideDown 0.3s ease-out;
          }

          @keyframes slideDown {
            from {
              transform: translateY(-100%);
            }
            to {
              transform: translateY(0);
            }
          }
          .subcat-filter-deals-wrapper {
            display: flex;
            flex-direction: row;
            max-width: 100%;
            width: 100%;
          }
          .main-deal-side-deal-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .new-filter-container {
            display: flex;
            margin-left: 10px;
            flex-direction: column;
            width: 75%;
            min-width: 0;
          }
          .right-content {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            position: relative;
            min-height: 40px;
            gap: 10px;
          }
          .selected-filter-desktop {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 0 0 0 -5px;
            flex: 1;
            min-width: 0;
          }
          .sort-btn-wrapper {
            position: relative;
            display: inline-block;
            flex-shrink: 0;
            min-width: 110px;
          }
          .sort-btn {
            display: flex;
            gap: 8px;
            align-items: center;
            padding: 8px 16px;
            position: relative;
            width: 100%;
            color: white;
            background-color: ${theme.colors.primary};
            border: 1px solid ${theme.colors.primary};
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
          }
          .sort-dropdown {
            position: absolute;
            right: 0;
            top: 100%;
            background: white;
            border: 1px solid #ddd;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            z-index: 1000;
            min-width: 180px;
            max-width: 250px;
            overflow: hidden;
          }
          .sort-option {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 10px 16px;
            background: none;
            border: none;
            text-align: left;
            cursor: pointer;
            font-size: 14px;
            color: #333;
          }
          .sort-option:hover {
            background-color: #f5f5f5;
          }
          .sort-option.selected {
            color: ${theme.colors.primary};
            font-weight: 600;
          }
          .sticky-side-menu {
            position: sticky;
            top: 20px;
            z-index: 999;
            align-self: flex-start;
            flex-shrink: 0;
          }
          .bg-container {
            position: fixed;
            height: 100vh;
            width: 100vw;
            object-fit: cover;
            z-index: -1;
            margin-top: -18rem;
          }
          .spacing {
            margin-top: 2%;
          }
          .row {
            width: 100%;
            margin-bottom: 20px;
          }
          .main-deal-wrapper {
            margin-bottom: 0;
            margin-top: ${currentNumberTiles > 0 ? '0px;' : '20px;'};
          }
          .full-row {
            width: 100%;
            margin-bottom: 20px;
          }
          .row-display {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .cols-display {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
          }
          .cols {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .cols-20 {
            width: 23%;
          }
          .cols-25 {
            width: 25%;
          }
          .cols-30 {
            width: 30%;
          }
          .cols-33 {
            width: 33%;
          }
          .cols-50 {
            width: 50%;
          }
          .cols-66 {
            width: 66%;
          }
          .cols-100 {
            width: 100%;
          }
          .main-deal-wrapper :global(.breadcrumb-container) {
            width: 100%;
            margin-bottom: 20px;
          }
          .faceted-navigation-container {
            width: 100%;
          }
          .side-menu-container {
            display: none;
          }
          :global(.hero-deals .social-cues-container__main-image__bottom) {
            z-index: 1;
          }
          .separator {
            margin-top: 10px;
            margin-bottom: 15px;
            border: 1px solid ${theme.colors.primary};
          }
          .with-sticky-filter-wrapper {
            display: flex;
            flex-direction: row;
            width: 100%;
            max-width: 900px !important;
            position: relative;
            min-height: 200px;
          }
          .timer-banner {
            text-align: center;
            background-color: ${theme.colors.primary};
            padding: 0.2rem 0.8rem;
          }
          // iPad
          @media (max-width: ${theme.breakpoints.xlDown}) {
            .head-container {
              width: 668px !important;
              margin: 0 auto;
            }
            .new-filter-container {
              display: none;
            }
            .main-deal-wrapper {
              flex-direction: column;
            }
            .hero-deals .cols-display {
              height: auto;
              flex-direction: row;
            }
            .main-deal-wrapper .main-deal {
              order: 2;
              width: 100%;
              margin-bottom: 20px;
              padding-right: 0px;
            }
            .main-deal-wrapper .hero-deals {
              width: 100%;
              order: 5;
            }
            .main-deal-wrapper .side-menu {
              width: 100%;
              order: 4;
              margin-bottom: 20px;
            }
            .main-deal-wrapper :global(.breadcrumb-container) {
              order: ${isNewFilterApplied ? 0 : 3};
            }
            .main-deal-wrapper
              .hero-deals
              :global(.secondary-deal:first-child) {
              margin-right: 20px;
            }
          } // 1199

          .timer-banner {
            text-align: center;
            background-color: ${theme.colors.primary};
            padding: 0.2rem 0.8rem;
          }

          // Mobile
          @media (max-width: ${theme.breakpoints.mdUp}) {
            // 768
            .container {
              padding: 0px;
            }
            .side-menu-container {
              display: block;
            }
            .row {
              padding-left: 0px;
              padding-right: 0px;
              margin-left: 0px;
              margin-right: 0px;
            }
            .main-deal-wrapper .hero-deals {
              display: block;
            }
            .main-deal-wrapper .main-deal-item {
              height: auto;
            }
            .item {
              width: 100%;
            }
            .deal {
              height: 300px !important;
              width: 100%;
            }
            .sort-btn-wrapper {
              min-width: auto;
              width: 100%;
            }
            .selected-filter-desktop {
              width: 100%;
            }
            .sort-dropdown {
              right: 0;
              left: auto;
              min-width: 160px;
            }
          }
          @media (max-width: ${theme.breakpoints.smUp}) {
            // side-menu first only for /deals/shop on mobile
            .main-deal-wrapper .side-menu-shop-and-local {
              order: 1;
            }
            .main-deal-wrapper {
              margin: 0;
            }
            .hero-deals .cols-display {
              flex-direction: column;
              margin: 0;
            }
            .main-deal-wrapper .main-deal {
              margin-bottom: 5px;
            }
            .main-deal-wrapper .side-menu {
              margin-bottom: 5px;
            }
            .main-deal-wrapper :global(.breadcrumb-container) {
              padding: 15px 16px 0 16px;
            }
            .sort-btn {
              font-size: 12px;
              padding: 6px 12px;
            }
          }
        `}</style>
        <style global jsx>{`
          html,
          body {
            padding: 0;
            margin: 0;
          }

          * {
            box-sizing: border-box;
          }

          .container-wrapper {
            min-height: 100vh;
          }
          .container-wrapper .container {
            padding: 0 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: ${isNewFilterApplied ? '1200px' : '1110px'};
          }

          @media (max-width: ${theme.breakpoints.mdUp}) {
            // 768
            .container-wrapper .container {
              width: 668px;
            }
          } // 728

          @media (max-width: ${theme.breakpoints.smDown}) {
            //575
            .container-wrapper .container {
              width: 100%;
              max-width: 100%;
              padding: 0;
              margin: 0;
            }

            .cols-display .ipad-row {
              width: 100% !important;
            }
          } //575

          .bottom-deals .card.xl-deal {
            margin-top: 0 !important;
          }

          @media (min-width: ${theme.breakpoints.smUp}) {
            .bottom-deals .card.xl-deal {
              margin-top: 20px !important;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store, req, query, res }) => {
    const cleanUrl = req?.url.includes('/_next/data')
      ? req?.url.replace(/_next\/data\/.+?\/|\.json/g, '')
      : req?.url;
    const dealsBeautySpaPattern = /^\/deals\/[^/]+\/beauty\/spa$/;
    if (isFindPage(req?.url)) {
      if (dealsBeautySpaPattern.test(cleanUrl)) {
        const updatedUrl = cleanUrl.replace('/deals', '/find');
        const loc = updatedUrl.split('/')[2];
        const destination = locationList.includes(loc)
          ? updatedUrl
          : updatedUrl.replace(loc, 'london');

        return {
          redirect: {
            destination,
            statusCode: 301,
          },
        };
      }

      return {
        redirect: {
          destination: cleanUrl.split('?')[0].replace('/deals', '/find'),
          statusCode: 301,
        },
      };
    }
    if (
      !isIELocation(cleanUrl) &&
      !cleanUrl.includes('near-me') &&
      process.env.NEXT_PUBLIC_SITE === SITE_WOWCHERIE
    ) {
      return {
        redirect: {
          basePath: false,
          destination: `https://www.wowcher.co.uk${cleanUrl}`,
          source: '/',
          statusCode: 301,
        },
      };
    }

    if (
      cleanUrl.includes('near-me') &&
      process.env.NEXT_PUBLIC_SITE === SITE_WOWCHERIE
    ) {
      return {
        notFound: true,
      };
    }

    const serverSideDeals = await store
      .dispatch(
        getServerSideDeals({
          path: req.url,
          query,
          secondaryDealsCount: NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY,
          ssr: true,
        }),
      )
      .catch((error) => {
        // console.log only visible in Server Side
        console.error(`getServerSideDeals error: ${error}`);
      });

    // core , page, products, navigation
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.error(`getServerSideEssentials , slug deal page: ${error}`);
    });

    const popularLocationsData = await getPopularLocations();
    const isNearMePage = req.url.includes('/near-me/');
    res.setHeader('Cache-Control', `public, max-age=${PAGE_CACHE_AGE_SEC}`);
    const isSDCookie = req.cookies[COOKIES.sdTest] === 'b';
    if (
      !req.url.includes('/_next/') &&
      !req.url.includes('near-me') &&
      (!serverSideDeals ||
        serverSideDeals?.length === 0 ||
        !serverSideDeals[0]?.mainDeal ||
        Object.keys(serverSideDeals[0]?.mainDeal).length === 0 ||
        !serverSideDeals[0]?.deals?.length)
    ) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        initialIsNewFilterApplied:
          isSDCookie && isFindPath(req.url) && !isNearMePage,
        popularLocationsData: popularLocationsData || [],
        url: req.url,
      },
    };
  },
);

// Title can not be created here, so we assign a title type
Deals.titletype = TYPE_CATEGORY_DEALS;
// Use the HeaderFooter Layout
Deals.layout = DealsLayout;
// Show the counterdown timer
Deals.countdown = true;

Deals.propTypes = {
  initialIsNewFilterApplied: PropTypes.bool,
  popularLocationsData: PropTypes.array,
  url: PropTypes.string,
};

export default Deals;
